export const timeGreetings = () => {
    const day = new Date();
    const hr = day.getHours();
    if (hr >= 0 && hr < 12) {
      return "Good Morning!";
    } else if (hr >= 12 && hr < 17) {
      return "Good Afternoon!";
    } else {
      return "Good Evening!";
    }
  };
  export const handleSpaces = (event) => {
    var e = window.event || event;
  
    var key = e.keyCode;
  
    //space pressed
  
    if (key === 32) {
      //space
  
      if (event.target.value < 1) event.preventDefault();
    }
  };
  export const functiondisable = () => {
    // To get the scroll position of current webpage
    let TopScroll = window.pageYOffset || document.documentElement.scrollTop;
    let LeftScroll = window.pageXOffset || document.documentElement.scrollLeft;
    // if scroll happens, set it to the previous value
    window.onscroll = function () {
      window.scrollTo(LeftScroll, TopScroll);
    };
  };
  export const functionenable = () => {
    window.onscroll = function () {};
  };

  /**
   * Extracts user-friendly error message from API error response
   * @param {Error} error - The error object from catch block
   * @param {string} defaultMessage - Default message if error format is unknown
   * @returns {string} User-friendly error message
   */
  export const getErrorMessage = (error, defaultMessage = 'Something went wrong. Please try again.') => {
    // Network error (no response from server)
    if (!error.response) {
      if (error.message === 'Network Error') {
        return 'Network error. Please check your connection and try again.';
      }
      return error.message || defaultMessage;
    }

    const { response } = error;
    const status = response?.status;
    const data = response?.data;

    // Handle different HTTP status codes
    if (status === 401) {
      if (typeof data?.message === 'string' && data.message.trim()) {
        return data.message;
      }
      return defaultMessage;
    }
    if (status === 403) {
      return 'You do not have permission to perform this action.';
    }
    if (status === 404) {
      return 'Resource not found.';
    }
    if (status === 500) {
      return 'Server error. Please try again later.';
    }

    // Extract message from response data
    if (data) {
      // If data has a message property
      if (typeof data.message === 'string' && data.message.trim()) {
        return data.message;
      }

      // If data has an error property
      if (typeof data.error === 'string' && data.error.trim()) {
        return data.error;
      }

      // If data is an object with multiple error fields
      if (typeof data === 'object' && !Array.isArray(data)) {
        const errorMessages = Object.entries(data)
          .filter(([key, value]) => value != null && value !== '')
          .map(([key, value]) => {
            // Handle array of errors
            if (Array.isArray(value)) {
              return value.join(', ');
            }
            // Handle object errors
            if (typeof value === 'object') {
              return Object.values(value).join(', ');
            }
            // Handle string errors
            return typeof value === 'string' ? `${key}: ${value}` : String(value);
          })
          .filter(msg => msg && msg.trim());

        if (errorMessages.length > 0) {
          return errorMessages.join('. ');
        }
      }

      // If data is a string
      if (typeof data === 'string' && data.trim()) {
        return data;
      }
    }

    // Fallback to status text or default message
    return response?.statusText || defaultMessage;
  };